import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { useAdvertContactsState, useAdvertContactsLoadContext } from '#advertContacts/hooks';
import {
  hide,
  open,
  setIsLoadInProcess,
  setIsLoaded,
} from '#advertContacts/reducers';

const useAdvertContactsVisibleControl = () => {
  const { isOpen, isLoaded } = useAdvertContactsState();
  const { AdvertContacts } = useAdvertContactsLoadContext();
  const dispatch = useDispatch();

  const triggerOpen = useCallback(() => {
    if (isLoaded) {
      dispatch(open());
      return;
    }

    dispatch(setIsLoadInProcess(true));
    AdvertContacts.load().then(() => {
      dispatch(setIsLoadInProcess(false));
      dispatch(setIsLoaded(true));
      dispatch(open());
    });
  }, [AdvertContacts, dispatch, isLoaded]);

  const triggerHide = useCallback((): Promise<void> => new Promise((resolve) => {
    dispatch(hide());

    setTimeout(() => {
      resolve();
    }, 400);
  }), [dispatch]);

  return {
    isOpen,
    open: triggerOpen,
    hide: triggerHide,
  };
};

export { useAdvertContactsVisibleControl };
